/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseOfSystemSettingsResponse } from '../models/ApiResponseOfSystemSettingsResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class SystemSettingsService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @deprecated
     * Deprecated in favor of using GrowthBook to manage configuration
     * @returns ApiResponseOfSystemSettingsResponse 
     * @throws ApiError
     */
    public getSystemSettings(): CancelablePromise<ApiResponseOfSystemSettingsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v2/system-settings/',
        });
    }

}
